import React from 'react';
import { Check, PhoneOff } from 'lucide-react';
import { ApptBadge } from './util';
import { LABEL, cx } from '../contacts/ui';

// Tap people to include/exclude them from the calling queue.
export const PickList = ({ items, picked, onToggle, onAll, onNone }) => (
  <div className="mt-4" data-testid="calling-pick-list">
    <div className="mb-2 flex items-center justify-between gap-2">
      <p className={cx(LABEL, 'mb-0')}>Tap to choose · {picked.size} of {items.length}</p>
      <div className="flex gap-3 text-xs font-semibold">
        <button type="button" onClick={onAll} data-testid="calling-pick-all" className="text-[var(--accent-ink)] hover:underline">Select all</button>
        <button type="button" onClick={onNone} data-testid="calling-pick-none" className="text-[var(--muted)] hover:underline">Clear</button>
      </div>
    </div>
    <ul className="max-h-[45vh] space-y-1 overflow-y-auto pr-1">
      {items.map((i) => {
        const on = picked.has(i.key);
        return (
          <li key={i.key}>
            <button type="button" onClick={() => onToggle(i.key)} aria-pressed={on} data-testid={`calling-pick-${i.key}`}
              className={cx('flex w-full items-center gap-3 rounded-xl border px-3 py-2.5 text-left transition-[background-color,opacity]', on ? 'border-[var(--line)] bg-[var(--surface-2)]' : 'border-transparent opacity-60 hover:opacity-100')}>
              <span className={cx('grid h-5 w-5 shrink-0 place-items-center rounded-md border-2', on ? 'border-[var(--accent)] bg-[var(--accent)] text-white' : 'border-[var(--line)]')}>{on && <Check className="h-3.5 w-3.5" strokeWidth={3} />}</span>
              <span className="min-w-0 flex-1">
                <span className="block truncate text-sm font-semibold text-[var(--ink)]">{i.name}</span>
                <span className="block truncate text-xs text-[var(--muted)]">{i.status_label}</span>
              </span>
              {i.next_appointment_at && <ApptBadge at={i.next_appointment_at} />}
              {!i.has_mobile && <span className="inline-flex items-center gap-1 text-[10px] font-bold text-[var(--red)]"><PhoneOff className="h-3 w-3" />No mobile</span>}
            </button>
          </li>
        );
      })}
    </ul>
  </div>
);
